// src/utils/emailUtils.js

/**
 * Sends an order confirmation email via the SendGrid Lambda
 * @param {Object} orderData - The complete order data
 * @returns {Promise<boolean>} - Whether the email was sent successfully
 */
export const sendOrderConfirmationEmail = async (orderData) => {
    try {
      // Transform order data to match the format expected by the SendGrid Lambda
      const emailOrderData = {
        customer_name: orderData.customerInfo.name,
        email: orderData.customerInfo.email,
        order_number: orderData.orderNumber,
        order_date: new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }),
        payment_status: 'Paid',
        delivery_method: orderData.deliveryMethod === 'delivery' ? 'Delivery' : 'Pickup',
        address: orderData.deliveryMethod === 'delivery' ? orderData.customerInfo.address : null,
        items: orderData.items.map(item => ({
          name: item.name,
          quantity: item.quantity,
          totalPrice: item.totalPrice || (item.unitPrice * item.quantity)
        })),
        subtotal: orderData.subtotal,
        discount_amount: orderData.discount || 0,
        promo_code: orderData.promoCode || '',
        delivery_fee: orderData.deliveryFee || 0,
        total: orderData.total
      };
  
      // Send order data to the SendGrid Lambda
      const response = await fetch('https://s9l70ztz3c.execute-api.us-east-1.amazonaws.com/default/bucks-sendgrid-customer-order-email-post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_data: emailOrderData }),
      });
  
      const emailResult = await response.json();
      
      if (!emailResult.success) {
        console.error('Email API returned error:', emailResult.message);
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('Error sending order confirmation email:', error);
      return false;
    }
  };